<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت درخواست موجودی کالا</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
            <v-card>
                <v-card-title>
                    <v-layout wrap row>
                       
                        <v-flex xs12 sm12 lg6 md6 xl6 style="padding:30px">
                            <v-layout row wrap>
                                
                                <v-flex xs12 sm12 md12 lg12 xl12 >
                                    <v-row>
                                       
                                     
                                        <v-col cols="12" >
                                            <JsonExcel :data="dtData" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExcelFields">
                                                <v-btn dark color="baseColor">
                                                    <v-icon small style="padding-left:5px;">fas fa-file-excel</v-icon>&nbsp;
                                                    خروجی اکسل
                                                </v-btn>
                                            </JsonExcel>
                                        </v-col>
                                    </v-row>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <v-data-table :items="dtData" :headers="dtHeaders">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
    </div>
    
</template>

<script>
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");

const axios = require('axios');
import JsonExcel from 'vue-json-excel'
import { async } from 'q';
export default {
    components:{
        JsonExcel
    },
    name:"amazingrequest",
    data:()=>({
        sStatus:-1,
        PayTypeFilter:0,
        dtHeaders:[
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان محصول",value:"a_ProductTitle",sortable:true,align:"right"},
            {text:"نوع اطلاع رسانی",value:"a_NotificationTypeStr",sortable:true,align:"right"},
            {text:"کاربر ",value:"a_UserName",sortable:true,align:"right"},
            {text:"تلفن ",value:"a_Email",sortable:true,align:"right"},
            {text:"ایمیل ",value:"a_Phone",sortable:true,align:"right"}
        ],
        dtData:[],
        Repository:[],
        ExcelFields:{
            'عنوان محصول':'a_ProductTitle',
            'نوع اطلاع رسانی':'a_NotificationTypeStr',
            'کاربر':'a_UserName',
            'ایمیل':'a_Email',
            'تلفن':'a_Phone',
        },
        schUser:null,
        schPhone:null,
        schSdate:null,
        schEdate:null,
        schMail:null,
        inSearching:false,
        OperationItem:[],
        selectedItem:{reciption:null},
        savingUpdates:false,
        deliver:"",
        price:0,
        reason:"",
        TicketDialog:false,
        Ticket:[],
        Entity:0,
        RegTicketRespLoading:false,
        ticketResponse:""
    }),
    created(){
        this.loadSuggestions();
    },
    methods:{
        async searchSuggestion()
        {
            let vm = this;
            vm.sStatus = 2;
            let data = {};
            if(vm.schUser != null)
            {
                data.User = vm.schUser;
            }
            if(vm.schPhone != null)
            {
                data.Phone = vm.schPhone;
            }
            if(vm.schSdate != null)
            {
                data.StartDate = vm.schSdate;
            }
            if(vm.schEdate != null)
            {
                data.EndDate = vm.schEdate;
            }
            if(vm.schMail != null)
            {
                data.Email = vm.schMail;
            }

                let sheet = {};
                sheet.searchModel = data; 
                var url="http://derics.barayand.net/api/setting/communication/searchConsultation";
                const config = 
                {
                    
                    url:url,
                    method: 'post',
                    data:sheet
                }
                await axios(config)
                    .then(function (res) {
                       
                        // vm.inUploading = false;
                        if(res.data.status)
                        {
                        vm.dtData = res.data.data;
                        vm.Repository = res.data.data;
                            // vm.documentFile = res.data.data;
                        }
                    })
                    .catch(function (error) {
                    
                    console.log(error);
                    });
            
        },
        async PayFilterChanged(e)
        {
            let vm = this;
           let f = e;
           vm.status = 0;
           if(f == 0)
           {   
                
                vm.dtData = vm.Repository;
          
               
           }
           else
           {
                vm.dtData = await vm.Repository.filter(({PayTypeBool})=>PayTypeBool == f );
           }
        },
        async filterChanged(e)
        {
           let vm = this;
           vm.PayTypeFilter = 0;
           let f = e;
           if(f == -1)
           {   
                
                vm.dtData = vm.Repository;
          
               
           }
           else
           {
                vm.dtData = await vm.Repository.filter(({status})=>status == f );
           }
        },
        async loadSuggestions()
        {
            let vm = this;
            var url=ApiUrl.LoadAmazingRequests+"/2";
            
            await axios.post(url)
                .then(function (res) {
                    console.log(res);
                    vm.inUploading = false;
                    if(res.data.status)
                    {
                       vm.dtData = res.data.data;
                       vm.Repository = res.data.data;
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        }
    }
}
</script>